import { z } from 'zod'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

export const useEm360PairingFormInitializer = (): { validationSchema: z.Schema } => {
  const { t } = useCustomTranslation()

  const validationSchema = z.object({
    pairingId: z
      .string()
      .transform(value => {
        const normalized = value.replaceAll(/[\s-]/g, '').trim().toUpperCase()
        const exact12 = normalized.match(/(^|[^0-9])([0-9]{12})(?![0-9])/)

        if (exact12) {
          return exact12[2]
        }

        return normalized
      })
      .superRefine((value, ctx) => {
        const isSerialNumber = /^\d{12}$/.test(value)
        const isProductSerialNumber = /^[A-Z0-9]{16}$/.test(value)

        if (isProductSerialNumber) {
          if (!value.startsWith('E3')) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              message: t('installation-configuration.em360.error.invalid-qntm-serial'),
            })
            return
          }
        }

        if (isSerialNumber) {
          if (!/^\d+$/.test(value)) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              message: t('installation-configuration.em360.error.only-numbers-after-prefix'),
            })
            return
          }

          if (!value.startsWith('37')) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              message: t('installation-configuration.em360.error.invalid-qntm-serial'),
            })
            return
          }
        }

        if (!isSerialNumber && !isProductSerialNumber) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: t('installation-configuration.em360.error.length'),
          })
          return
        }
      }),
  })

  return { validationSchema }
}
